module.exports = __webpack_public_path__ + "static/media/paly.cc765155.PNG";